/**
 * @generated SignedSource<<7fdf6ebb0f4b0c103ea0627e588086fa>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type TownsquareProjectStateValue = "archived" | "at_risk" | "cancelled" | "done" | "off_track" | "on_track" | "paused" | "pending" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type projectTitleMetadata_AtlassianSearchPage$data = {
  readonly project: {
    readonly dueDate: {
      readonly label: string | null | undefined;
    } | null | undefined;
    readonly isPrivate: boolean;
    readonly state: {
      readonly label: string | null | undefined;
      readonly value: TownsquareProjectStateValue | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "projectTitleMetadata_AtlassianSearchPage";
};
export type projectTitleMetadata_AtlassianSearchPage$key = {
  readonly " $data"?: projectTitleMetadata_AtlassianSearchPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"projectTitleMetadata_AtlassianSearchPage">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "label"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "projectTitleMetadata_AtlassianSearchPage",
  "selections": [
    {
      "concreteType": "TownsquareProject",
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isPrivate"
        },
        {
          "concreteType": "TownsquareTargetDate",
          "kind": "LinkedField",
          "name": "dueDate",
          "plural": false,
          "selections": [
            (v0/*: any*/)
          ]
        },
        {
          "concreteType": "TownsquareProjectState",
          "kind": "LinkedField",
          "name": "state",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "kind": "ScalarField",
              "name": "value"
            }
          ]
        }
      ]
    }
  ],
  "type": "SearchResultAtlasProject"
};
})();

(node as any).hash = "e1cfd426806d5804439f761565129f8f";

export default node;
